/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { validateFileMaxSize } from '@app/common/validators/file';

@Component({
  selector: 'file-input',
  templateUrl: 'file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressBarModule, MatButtonModule, NgClass],
})
export class FileInputComponent {
  @Input() formArray?: FormArray<FormControl<File | null>>;
  @Input() maxFileSizeInBytes = 0;
  @Input() uploadProgressInPercents?: number | null;

  public dragOver = false;

  onDragover(e: DragEvent) {
    e.preventDefault();
    this.dragOver = true;
  }
  onDragleave(e: DragEvent) {
    e.preventDefault();
    this.dragOver = false;
  }
  private setFilesValue(files: File[]) {
    files.forEach((file) => {
      if (this.formArray)
        this.formArray.push(new FormControl<File>(file, [validateFileMaxSize(this.maxFileSizeInBytes)]));
    });
  }
  onDrop(e: DragEvent) {
    e.preventDefault();
    this.setFilesValue(Array.from(e.dataTransfer?.files ?? []));
  }
  onFileInputChange(e: Event) {
    const input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    const files: File[] = Array.from(input.files ?? []);
    this.setFilesValue(files);
    input.value = '';
  }
}
